import {PitchService} from './pitch.service';

export const PitchInjectables: Array<any> = [
  {
    provide: PitchService,
    useClass: PitchService,
  },
];
